import styled from "@emotion/styled";
import { Button, Divider, Form, Input, message, Radio, Select } from "antd";
import { FC, useEffect } from "react";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";
import { RegistrationParam } from "../../module/registration/param/registration.param";
import registrationService from "../../module/registration/service/registration.service";

const breadArr = [
	{
		title: "关于我们",
	},
	{
		title: "CAP软件注册",
	},
];

const onFinish = async (value: RegistrationParam) => {
	const {data} = await registrationService.add(value);
	message.success(data);
	location.reload();
};

export const Registration: FC = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<Container>
			<ImageFill src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/vhs-assets-css-21463021cd10d16695381184f646e421.jpg"} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>CAP软件注册</h1>
				</div>
				<Bread value={breadArr} />
				<div style={{ marginBottom: "3rem" }}>欧皮特CAP驱动程序是用于皮带驱动的计算和设计。 注册后将获得一个免费的授权码，授权后享受不受限制的软件使用。</div>
				<Form className='form' onFinish={onFinish} labelCol={{ span: 4 }}>
					<Form.Item name={"customerNum"} label='欧皮特推荐码'>
						<Input />
					</Form.Item>
					<Form.Item
						name={"email"}
						label='用户名/邮箱'
						rules={[
							{
								required: true,
								message: "请输入您的用户名/邮箱!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item
						name={"password"}
						label='密码'
						rules={[
							{
								required: true,
								message: "请输入您的密码!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item
						name={"confirmPassword"}
						dependencies={["password"]}
						hasFeedback
						rules={[
							{
								required: true,
								message: "请确认您的密码!",
							},
							({ getFieldValue }) => ({
								validator(_, value) {
									if (!value || getFieldValue("password") === value) {
										return Promise.resolve();
									}
									return Promise.reject(new Error("密码不一致!"));
								},
							}),
						]}
						label='确认密码'>
						<Input />
					</Form.Item>
					<Divider />
					<Form.Item
						name={"gender"}
						rules={[
							{
								required: true,
								message: "请选择性别!",
							},
						]}
						label='性别'>
						<Select>
							<Select.Option value='男'>男</Select.Option>
							<Select.Option value='女'>女</Select.Option>
						</Select>
					</Form.Item>
					<Form.Item
						name={"name"}
						label='名'
						rules={[
							{
								required: true,
								message: "请输入您的名!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item
						name={"familyName"}
						label='姓'
						rules={[
							{
								required: true,
								message: "请输入您的姓!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item
						name={"company"}
						label='公司'
						rules={[
							{
								required: true,
								message: "请输入您的公司名!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item name={"department"} label='部门'>
						<Input />
					</Form.Item>
					<Form.Item
						name={"country"}
						label='国家'
						rules={[
							{
								required: true,
								message: "请输入您的国家!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item
						name={"city"}
						label='城市'
						rules={[
							{
								required: true,
								message: "请输入您的城市!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item
						name={"street"}
						label='街道'
						rules={[
							{
								required: true,
								message: "请输入您的街道!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item
						name={"zip"}
						label='邮政编码'
						rules={[
							{
								required: true,
								message: "请输入邮政编码!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item
						name={"businessType"}
						label='业务类型'
						rules={[
							{
								required: true,
								message: "请输入您的业务类型!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item
						name={"phone"}
						label='手机号'
						rules={[
							{
								required: true,
								message: "请输入您的手机号!",
							},
						]}>
						<Input />
					</Form.Item>
					<Form.Item name={"fax"} label='传真'>
						<Input />
					</Form.Item>
					<Form.Item name={"newsletterIndustry"} label='行业新闻订阅'>
						<Radio.Group>
							<Radio.Button value={1}>订阅</Radio.Button>
							<Radio.Button value={0}>不订阅</Radio.Button>
						</Radio.Group>
					</Form.Item>
					<Form.Item name={"newsletterAutomotive"} label='汽车新闻订阅'>
						<Radio.Group>
							<Radio.Button value={1}>订阅</Radio.Button>
							<Radio.Button value={0}>不订阅</Radio.Button>
						</Radio.Group>
					</Form.Item>
					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type='primary' htmlType='submit'>
							提交
						</Button>
					</Form.Item>
				</Form>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		background: white;
		z-index: 10;
		position: relative;

		.form {
			width: 70%;
			margin: 0 auto;
		}
	}
`;
